import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import SalaryReconciliationsApiHandler from 'app/services/salaryReconciliationsApiHandler';

import { SalaryReconciliationReport } from 'app/types/salaryReconciliations';

export const SALARY_RECONCILIATION_REPORT_QUERY_KEY = 'fetchSalaryReconciliationReport';

/**
 * Reads a salary accrual reconciliation run's report, limited to one company when one is given. A run without a report
 * gives null rather than an error, so the page can say there is no report.
 */
const useFetchSalaryReconciliationReport = (id?: string, companyId?: string, enabled = true) =>
  useQuery<SalaryReconciliationReport | null, Error>(
    [SALARY_RECONCILIATION_REPORT_QUERY_KEY, id, companyId],
    async () => {
      try {
        return await SalaryReconciliationsApiHandler.getReconciliationReport({
          id: id as string,
          companyId,
        });
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    { enabled: enabled && !!id }
  );

export default useFetchSalaryReconciliationReport;
